import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { PlatformService } from '@ld.consumer-portal/utils';
import { map } from 'rxjs';

export type LoanType = 'MORTGAGE' | 'HELOC' | 'HOME_EQUITY';

export interface LoanSelectorAccount {
  id: string;
  type: LoanType;
  address: string;
}

@Component({
  selector: 'ld-page-header',
  imports: [MatIconModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  private readonly platformService = inject(PlatformService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  private readonly isNativeMobile = this.platformService.isNativeMobile;

  private readonly isMobileViewport = toSignal(
    this.breakpointObserver.observe('(max-width: 767px)').pipe(map((result) => result.matches)),
    { initialValue: this.breakpointObserver.isMatched('(max-width: 767px)') },
  );

  protected readonly isMobile = computed(() => this.isNativeMobile() || this.isMobileViewport());

  readonly backLabel = input.required<string>();

  readonly pageTitle = input<string>();

  readonly pageTitleHighlight = input<string>();

  readonly backClick = output<void>();

  onBackClick(): void {
    this.backClick.emit();
  }
}
